import { useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { APIContext } from 'context/APIContext'
import { PencilSquareIcon, DocumentDuplicateIcon, Cog6ToothIcon } from '@heroicons/react/24/outline'
import kinesisLogo from 'media/kinesis_logo.png'

export default function ProgramPlaygroundHeader({ programMetadata = null }) {

    const navigate = useNavigate()
    
    const { urlProgramId } = useParams()

    const { ShowModal } = useContext(ModalContext)
    const { DuplicateProgram } = useContext(APIContext)

    const ShowDuplicateProgramModal = (program) => {
        const modalData = {
            key: ModalKey.ActionWarning,
            size: 'quarter',
            titleText: 'Duplicate ' + program.name + '?',
            bodyText: [
                'This will create a new program with the same goals and exercises as the original program',
            ],
            buttonText: 'Duplicate',
            buttonAction: async () => __DuplicateProgram()
        }

        ShowModal(modalData)
    }

    const __DuplicateProgram = async () => {
        const newProgramId = await DuplicateProgram('programId', programMetadata.programId, null, null, null)

        if (newProgramId === null) {
            console.error('Failed to duplicate program')
            return
        }

        navigate(`/program/${newProgramId}/playground`)

        window.location.reload()
    }

    if (programMetadata === null) return null

    return (
        <div className='flex items-center gap-x-4'>
            <div className='flex-1 flex items-center gap-x-4'>
                <img
                    src={kinesisLogo}
                    alt="Program Definition Logo"
                    className="h-12 w-12"
                />

                <div className='mb-0.5 pr-2 flex-grow'>
                    <h1 className="text-xl font-semibold text-gray-900 tracking-tight flex-grow">
                        {programMetadata?.name}
                    </h1>

                    <p className="text-sm">
                        {programMetadata?.description?.length > 0 ? programMetadata?.description : 'No Description'}
                    </p>
                </div>
            </div>

            <div
                className='w-12 h-12 bg-white rounded-lg shadow-md flex items-center justify-center cursor-pointer'
                onClick={() => ShowDuplicateProgramModal(programMetadata)}
            >
                <DocumentDuplicateIcon className='w-6 h-6 text-gray-500' />
            </div>

            <div
                className='w-12 h-12 bg-white rounded-lg shadow-md flex items-center justify-center cursor-pointer'
                onClick={() => navigate(`/program/${urlProgramId}/canvas`)}
            >
                <PencilSquareIcon className='w-6 h-6 text-gray-500' />
            </div>

            <div
                className='w-12 h-12 bg-white rounded-lg shadow-md flex items-center justify-center cursor-pointer'
                onClick={() => navigate(`/program/${urlProgramId}/settings`)}
            >
                <Cog6ToothIcon className='w-7 h-7 text-gray-500' />
            </div>
        </div>
    )
}